import type { ReactNode } from "react";

export function TermsOfService() {
  return (
    <div style={{
      maxWidth: "720px", margin: "0 auto", padding: "48px 24px",
      color: "var(--color-text-primary)", lineHeight: 1.7,
    }}>
      <h1 style={{ fontSize: "24px", fontWeight: 700, marginBottom: "8px" }}>Terms of Service</h1>
      <p style={{ color: "var(--color-text-muted)", fontSize: "13px", marginBottom: "32px" }}>
        Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
      </p>

      <Section title="Acceptance of terms">
        <p>By creating an account or using Stride, you agree to these Terms of Service. If you do not agree, please do not use the service.</p>
      </Section>

      <Section title="Service description">
        <p>Stride is a task management tool that helps you organize and track your work and personal tasks. We provide features including task tracking, project organization, calendar integration, and recurring task management.</p>
      </Section>

      <Section title="Payment terms">
        <p>Stride offers a 14-day free trial with no credit card required. After the trial period, continued access requires a monthly subscription. You can cancel your subscription at any time from Settings, and your access will continue until the end of the current billing period. We do not offer refunds for partial months.</p>
      </Section>

      <Section title="Acceptable use">
        <p>You agree not to use Stride to:</p>
        <ul style={{ paddingLeft: "20px" }}>
          <li>Violate any applicable laws or regulations</li>
          <li>Attempt to gain unauthorized access to our systems or other users' accounts</li>
          <li>Scrape, crawl, or systematically extract data from the service</li>
          <li>Interfere with or disrupt the integrity or performance of the service</li>
        </ul>
      </Section>

      <Section title="Limitation of liability">
        <p>Stride is provided "as is" without warranties of any kind. We do not guarantee uninterrupted or error-free service. To the maximum extent permitted by law, we are not liable for any indirect, incidental, or consequential damages arising from your use of the service.</p>
      </Section>

      <Section title="Termination">
        <p>We reserve the right to suspend or terminate accounts that violate these terms, with or without notice. You may delete your account at any time from Settings. Upon termination, your data will be removed in accordance with our Privacy Policy.</p>
      </Section>

      <Section title="Changes to terms">
        <p>We may update these terms from time to time. We will notify you of significant changes via email. Continued use of the service after changes take effect constitutes acceptance of the updated terms.</p>
      </Section>

      <Section title="Contact">
        <p>Questions about these terms? Reach out at the email address on our website.</p>
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div style={{ marginBottom: "28px" }}>
      <h2 style={{ fontSize: "16px", fontWeight: 600, marginBottom: "12px" }}>{title}</h2>
      <div style={{ color: "var(--color-text-secondary, var(--color-text-muted))", fontSize: "14px" }}>{children}</div>
    </div>
  );
}
